<form class="setup-step" [formGroup]="mainForm" (ngSubmit)="onSubmit()">
  <div class="text-center my-2 setup-step__header">
    <h1 class="mb-1">{{ 'onboarding.setup.companySetup.title' | translate }}</h1>
    <p class="m-0">{{ 'onboarding.setup.companySetup.subtitle' | translate }}</p>
  </div>

  <div class="row g-4">
      <div class="col-md-6 d-flex" formGroupName="company_data">
        <div class="av-section">
          <div class="av-section__header">
            <mat-icon class="av-section__icon icon-md">business</mat-icon>
            <h2 class="av-section__title fw-bold mb-0">
              {{ 'onboarding.setup.companySetup.companyInfo' | translate }}
            </h2>
            <span class="av-section__divider"></span>
          </div>

          <div class="av-content-box">
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100">
              <mat-label>{{ 'onboarding.setup.companySetup.nameLabel' | translate }}</mat-label>
              <input
                matInput
                formControlName="name"
                [placeholder]="'onboarding.setup.companySetup.namePlaceholder' | translate"
                autocomplete="organization"
              />
              <mat-icon matPrefix>business</mat-icon>
              <mat-hint>{{ 'onboarding.setup.companySetup.hints.orgName' | translate }}</mat-hint>
              @if (mainForm.get('company_data.name')?.touched &&
              mainForm.get('company_data.name')?.invalid) {
              <mat-error>{{ 'onboarding.setup.companySetup.nameError' | translate }}</mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100">
              <mat-label>{{ 'onboarding.setup.companySetup.domainLabel' | translate }}</mat-label>
              <input
                matInput
                formControlName="domain"
                [placeholder]="'onboarding.setup.companySetup.domainPlaceholder' | translate"
                autocomplete="off"
              />
              <mat-icon matPrefix>language</mat-icon>
              <mat-icon
                matSuffix
                class="av-hint-icon icon-sm"
                matTooltip="{{ 'onboarding.setup.companySetup.hints.domain' | translate }}"
                matTooltipPosition="above"
                >info</mat-icon
              >
              <mat-hint>{{ 'onboarding.setup.companySetup.hints.domain' | translate }}</mat-hint>
              @if (mainForm.get('company_data.domain')?.touched &&
              mainForm.get('company_data.domain')?.invalid) {
              <mat-error>{{ 'onboarding.setup.companySetup.domainError' | translate }}</mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100">
              <mat-label>{{ 'onboarding.setup.companySetup.nicknameLabel' | translate }}</mat-label>
              <input matInput formControlName="avyna_nickname" autocomplete="off" />
              <mat-icon matPrefix>badge</mat-icon>
              <mat-icon
                matSuffix
                class="av-hint-icon icon-sm"
                matTooltip="{{ 'onboarding.setup.companySetup.nicknameHint' | translate }}"
                matTooltipPosition="above"
                >info</mat-icon
              >
              <mat-hint>{{ 'onboarding.setup.companySetup.hints.nickname' | translate }}</mat-hint>
              @if (mainForm.get('company_data.avyna_nickname')?.touched &&
              mainForm.get('company_data.avyna_nickname')?.invalid) {
              <mat-error>{{ 'onboarding.setup.companySetup.nicknameError' | translate }}</mat-error>
              }
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="col-md-6 d-flex" formGroupName="onboarder_data">
        <div class="av-section">
          <div class="av-section__header">
            <mat-icon class="av-section__icon icon-md">person</mat-icon>
            <h2 class="av-section__title fw-bold mb-0">
              {{ 'onboarding.setup.companySetup.identity.title' | translate }}
            </h2>
            <span class="av-section__divider"></span>
          </div>

          <div class="av-content-box">
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100">
              <mat-label>{{ 'onboarding.setup.companySetup.firstNameLabel' | translate }}</mat-label>
              <input matInput formControlName="first_name" autocomplete="given-name" />
              <mat-icon matPrefix>person</mat-icon>
              <mat-hint>{{ 'onboarding.setup.companySetup.identity.fromMicrosoft' | translate }}</mat-hint>
            </mat-form-field>

            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100">
              <mat-label>{{ 'onboarding.setup.companySetup.lastNameLabel' | translate }}</mat-label>
              <input matInput formControlName="last_name" autocomplete="family-name" />
              <mat-icon matPrefix>person</mat-icon>
              <mat-hint>{{ 'onboarding.setup.companySetup.identity.fromMicrosoft' | translate }}</mat-hint>
            </mat-form-field>

            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100">
              <mat-label
                >{{ 'onboarding.setup.companySetup.phoneLabel' | translate }}
                <span class="text-body-secondary">{{
                  'onboarding.setup.companySetup.phoneOptional' | translate
                }}</span></mat-label
              >
              <input
                matInput
                formControlName="phone"
                [placeholder]="'onboarding.setup.companySetup.phonePlaceholder' | translate"
                autocomplete="tel"
                type="tel"
              />
              <mat-icon matPrefix>phone</mat-icon>
              <mat-hint>{{ 'onboarding.setup.companySetup.hints.phone' | translate }}</mat-hint>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>

  @if (errorMessage) {
  <div class="av-alert av-alert--error d-flex align-items-center gap-2 mt-3">
    <mat-icon>error</mat-icon>
    <span>{{ errorMessage }}</span>
  </div>
  }

  <div class="setup-step__actions d-flex justify-content-end mt-4">
    @if (loading) {
    <button mat-flat-button color="primary" type="submit" disabled class="px-4 rounded-full">
      {{ 'onboarding.setup.companySetup.saving' | translate }}
    </button>
    } @else {
    <button mat-flat-button color="primary" type="submit" class="px-4 rounded-full">
      {{ 'onboarding.setup.companySetup.continue' | translate }}
      <mat-icon iconPositionEnd>arrow_forward</mat-icon>
    </button>
    }
  </div>
</form>
